import styled from "styled-components/macro";
import React from "react";
import {
  TMessage,
  IFulfilledChat
} from "../../../../interfaces/interfacesChat";

const Root = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
`;

const Inner = styled.div`
  padding: 16px;
  background: #f4f4f4;
  border-radius: 8px;
  text-align: center;
  @media ${(props) => props.theme.media.phone} {
    font-size: 14px;
  }
`;
const TextTitle = styled.div`
  font-weight: 600;
  font-size: 18px;
  @media ${(props) => props.theme.media.phone} {
    font-size: 14px;
  }
`;

const Text = styled.div``;

interface IRejectedMessage {
  message: TMessage;
  t: Function;
  chat: IFulfilledChat;
}

export const HostAcceptedInviteMessage: React.FC<IRejectedMessage> = React.memo(
  ({ t, chat }) => {
    return (
      <Root>
        <Inner>
          <TextTitle>
            {t("systemMessages.candidateAccepted.title", {
              name: chat?.conversation_partner_short?.first_name
            })}
          </TextTitle>
          <Text>
            {t("systemMessages.candidateAccepted.text", {
              name: chat?.conversation_partner_short?.first_name
            })}
          </Text>
        </Inner>
      </Root>
    );
  }
);
